export default __webpack_public_path__ + "static/media/light.8bdca7a3.png";